__turbopack_context__.v({
  "closeButton": "AppSearchMobile-module-scss-module__-B35Qq__closeButton",
  "content": "AppSearchMobile-module-scss-module__-B35Qq__content",
  "divider": "AppSearchMobile-module-scss-module__-B35Qq__divider",
  "filtersWrapper": "AppSearchMobile-module-scss-module__-B35Qq__filtersWrapper",
  "header": "AppSearchMobile-module-scss-module__-B35Qq__header",
  "inputSection": "AppSearchMobile-module-scss-module__-B35Qq__inputSection",
  "mobileContent": "AppSearchMobile-module-scss-module__-B35Qq__mobileContent",
  "mt1": "AppSearchMobile-module-scss-module__-B35Qq__mt1",
  "root": "AppSearchMobile-module-scss-module__-B35Qq__root",
  "title": "AppSearchMobile-module-scss-module__-B35Qq__title",
  "toggleButton": "AppSearchMobile-module-scss-module__-B35Qq__toggleButton",
  "top": "AppSearchMobile-module-scss-module__-B35Qq__top",
  "wrapper": "AppSearchMobile-module-scss-module__-B35Qq__wrapper",
});
